<template>
  <v-flex x16 class="sortable-handler">
    <v-card>
     
      <v-dialog v-model="showModal" hide-overlay transition="dialog-bottom-transition" class="sortable-handler" persistent>
          <v-card>
            <v-toolbar dark style="background-color:#138315">
                <v-toolbar-title>Create User</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                <v-btn icon dark @click="$emit('close-modal-create-user')">
                    <v-icon>close</v-icon>
                </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-layout row wrap class="pa-4">
                <v-flex xs12 class="pa-1">
                <v-card class="pa-2">
                    <h4>Register User</h4>
                    <v-form ref="storeData" @submit.prevent="storeData()">
                      <v-select
                        :items="listOfClients"
                        item-text="name"
                        v-model="form.client"
                        label="Select a Client for User"
                        return-object
                        v-if="currentUser.role == 'admin'"
                      ></v-select>
                    
                      <v-text-field
                        v-model="form.name"
                        label="Name"
                        v-validate="'required|max:75'"
                        :error-messages="errors.collect('name')"
                        data-vv-name="name"
                      > </v-text-field>

                      <v-text-field
                        v-model="form.email"
                        label="Email"
                        :error-messages="errors.collect('email')"
                        data-vv-name="email"
                      > </v-text-field>

                      <v-text-field
                        class="mb-0 mt-0"
                        v-model="form.password"
                        label="Password"
                        :error-messages="errors.collect('password')"
                        data-vv-name="password"
                        type="password"
                      > </v-text-field>

                      <v-select
                          :items="listOfRoles"
                          v-model="form.role"
                          label="Select a Role for User"
                      ></v-select>
                      
                      <v-flex class="text-xs-right" shrink>
                        <v-btn
                          color="primary"
                          dark
                          class="text-md-left text-sm-left"
                          type="submit"
                        > Save </v-btn>
                      </v-flex>
                    </v-form>
                </v-card>
                </v-flex>
            </v-layout>
          </v-card>
      </v-dialog>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CreateUser',
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        client: null,
        password: null,
        role: 'client',
      },
      listOfClients: [],
      listOfRoles: ['client', 'manager']
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  mounted () {
    this.loadClients();
  },
  methods: {
    loadClients () {
      let url = '/clients/list';
      window.axios.get(url).then((response) => {
        this.listOfClients = response.data.data;
      });
    },
    storeData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('setLoading', true);
          let url = '/users';
          let payload = {
            name: this.form.name,
            email: this.form.email,
            client: this.form.client,
            password: this.form.password,
            role: this.form.role
          };

          window.axios.post(url, payload).then((response) => {
            this.$store.dispatch('setSnackbar', {
              show: true,
              color: 'success',
              text: 'User created suscessfully'
            });
            this.$store.dispatch('setLoading', false);
            this.$emit('update-users');
          }).catch(error => {
            this.$store.dispatch('setLoading', false);
            this.$store.dispatch('setSnackbar', {
              show: true,
              color: 'danger',
              text: 'Check the form, please.'
            });
          });
        }
      });
      
    }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/commons/users/modals/Create.vue